import React from 'react'
import moment from 'moment'
import { professionalDetailsDisplayMap } from 'common/types/MemberProfile'

interface ProfessionalDetailsItemProps {
  keyName: string
  value: any
}

export const ProfessionalDetailsItem = ({
  keyName,
  value,
}: ProfessionalDetailsItemProps) => {
  if (value === null || value === '') return null

  const isDate = (value: string) =>
    moment(value, moment.ISO_8601, true).isValid()

  let displayValue
  if (Array.isArray(value)) {
    displayValue = value.join(' ')
  } else if (typeof value === 'boolean') {
    displayValue = value ? 'Yes' : 'No'
  } else if (isDate(value)) {
    displayValue = moment(value).format('D MMM YYYY')
  } else {
    displayValue = value.toString()
  }

  const label =
    professionalDetailsDisplayMap[keyName] || keyName.replace(/_/g, ' ')

  return (
    <span key={keyName}>
      <h4 className='inline font-medium text-base text-[#093269]'>{label}: </h4>
      <p className='inline text-sm text-[#405985]'>{displayValue}</p>
    </span>
  )
}
